/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svtag_WorkerInputs */

const en_svtag_worker = /** @type {(inputs: Svtag_WorkerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#WORKER`)
};

const ar_svtag_worker = /** @type {(inputs: Svtag_WorkerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#عامل`)
};

const bn_svtag_worker = /** @type {(inputs: Svtag_WorkerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#WORKER`)
};

const de_svtag_worker = /** @type {(inputs: Svtag_WorkerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#WORKER`)
};

const es_svtag_worker = /** @type {(inputs: Svtag_WorkerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#WORKER`)
};

const fr_svtag_worker = /** @type {(inputs: Svtag_WorkerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#WORKER`)
};

const pt_svtag_worker = /** @type {(inputs: Svtag_WorkerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#WORKER`)
};

const zh_svtag_worker = /** @type {(inputs: Svtag_WorkerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#WORKER`)
};

const tr_svtag_worker = /** @type {(inputs: Svtag_WorkerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#WORKER`)
};

const ru_svtag_worker = /** @type {(inputs: Svtag_WorkerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#WORKER`)
};

const pl_svtag_worker = /** @type {(inputs: Svtag_WorkerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#WORKER`)
};

/**
* | output |
* | --- |
* | "#WORKER" |
*
* @param {Svtag_WorkerInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
export const svtag_worker = /** @type {((inputs?: Svtag_WorkerInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svtag_WorkerInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svtag_worker(inputs)
	if (locale === "bn") return bn_svtag_worker(inputs)
	if (locale === "de") return de_svtag_worker(inputs)
	if (locale === "es") return es_svtag_worker(inputs)
	if (locale === "fr") return fr_svtag_worker(inputs)
	if (locale === "pt") return pt_svtag_worker(inputs)
	if (locale === "zh") return zh_svtag_worker(inputs)
	if (locale === "tr") return tr_svtag_worker(inputs)
	if (locale === "ru") return ru_svtag_worker(inputs)
	if (locale === "pl") return pl_svtag_worker(inputs)
	return en_svtag_worker(inputs)
});